export default {"src":"/_next/static/image/public/images/flags/flag_256.ff35d231633308a1e42cc634aabdf10b.svg","height":16,"width":24};